














import { defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-promotion-brand-track-type';

export default defineComponent({
  name,
  props: {
    value: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array as PropType<{ value: number; label: string }[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const onInput = (val: number) => {
      emit('input', val);
    };
    const onChange = (val: number) => {
      emit('change', val);
    };
    return {
      name,
      onInput,
      onChange,
    };
  },
});
